// AlCapone CSS variable/value definitions
@use '~@mc-alberta/alcapone/dist/styles/variables.scss';
@use '~@mc-alberta/alcapone/dist/styles/mainLight.min.css';

:host,
:host(:not([dark])) {
  @extend %global-variables;
  --src-learn-more-font-family: inherit;
  --src-learn-more-header-size: 36px;
  --src-learn-more-text-size: 1rem;
  --src-btn-width: inherit;
  --src-btn-height: inherit;
  --src-learn-more-header-color: var(--src-color-orange-high);
  --src-learn-more-font-color: var(--src-color-foreground);

  display: block;
  width: 100%;
  font-family: var(--src-learn-more-font-family, 'system-ui');

  .container {
    .display-xl {
      font-size: var(--src-learn-more-header-size);
      color: var(--src-learn-more-font-color);
      font-family: var(--src-learn-more-font-family);
    }

    .color-orange-high {
      color: var(--src-learn-more-header-color);
    }

    .heading-md {
      font-family: var(--src-learn-more-font-family);
      font-size: var(--src-learn-more-text-size);
      color: var(--src-learn-more-font-color);
    }
    
    .weight-light {
      font-size: var(--src-learn-more-text-size);
      color: var(--src-learn-more-font-color);
    }

    .list__item--extra-space {
      margin-left: 12px;
    }

    *:focus-visible {
      outline: var(--src-accessibility-outline);
      outline-offset: var(--src-accessibility-outline-offset);
    }
  }
}

.col-3,
.col-1 {
  padding: 0;
}

//Dark mode styling
:host([dark]) {
  @extend %global-variables;
  --src-btn-width: inherit;
  --src-btn-height: inherit;
  font-family: var(--src-learn-more-font-family, 'system-ui');
  
  .container {
    background-color: var(--src-color-background);
  }

  .display-xl,
  .heading-md {
    font-family: var(--src-learn-more-font-family);
  }

  .list__item--bullet {
    color: var(--src-color-foreground);
  }
}